module.exports = __webpack_public_path__ + "static/media/instagram.0764d56a.svg";